import { render, staticRenderFns } from "./ShuifeijiDetails.vue?vue&type=template&id=19989076"
import script from "./ShuifeijiDetails.vue?vue&type=script&lang=js"
export * from "./ShuifeijiDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports